export default __webpack_public_path__ + "static/media/misc-fireplaceA-480w.eb252522.png";